import axios from "axios";

export const state = {
    feescarts: [],
};

export const getters = {
    feescarts: state => state.feescarts,
};

export const mutations = {
    setCart(state, newValue) {
        state.feescarts = newValue
    },
};

export const actions = {
    fetchFeesCart({ commit }) {
        axios.get('/feescarts').then(res => {
            commit('setCart', res.data.carts);
        })
    },
};
